import { render, staticRenderFns } from "./LinkSection.vue?vue&type=template&id=9b0522c2&scoped=true"
import script from "./LinkSection.vue?vue&type=script&lang=ts"
export * from "./LinkSection.vue?vue&type=script&lang=ts"
import style0 from "./LinkSection.vue?vue&type=style&index=0&id=9b0522c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0522c2",
  null
  
)

export default component.exports